var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
	html:true,
	title:_vm.text,
	interactive:false,
	variant: _vm.variant,
}),expression:"{\n\thtml:true,\n\ttitle:text,\n\tinteractive:false,\n\tvariant,\n}"}],staticClass:"tip-ico",attrs:{"name":"mdi.information"}})}
var staticRenderFns = []

export { render, staticRenderFns }